export type ActionUrlValidationResult =
  | {
      isValid: true;
      url: string;
    }
  | {
      isValid: false;
      errorKey:
        | "action_url.empty_result"
        | "action_url.invalid_result_type"
        | "action_url.invalid_url"
        | "action_url.unsafe_url";
    };

const UNSAFE_SCHEME_REGEX = /^(?:javascript|data|vbscript):/i;

export function validateExpressionActionUrl(
  result: unknown,
): ActionUrlValidationResult {
  if (result === undefined || result === null) {
    return { isValid: false, errorKey: "action_url.empty_result" };
  }

  if (typeof result !== "string" && typeof result !== "number") {
    return { isValid: false, errorKey: "action_url.invalid_result_type" };
  }

  const url = String(result).trim();
  if (!url) {
    return { isValid: false, errorKey: "action_url.empty_result" };
  }

  if (UNSAFE_SCHEME_REGEX.test(url)) {
    return { isValid: false, errorKey: "action_url.unsafe_url" };
  }

  if (url.startsWith("//")) {
    return { isValid: false, errorKey: "action_url.unsafe_url" };
  }

  if (url.startsWith("/")) {
    return { isValid: true, url };
  }

  try {
    const parsed = new URL(url);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return { isValid: true, url };
    }
    return { isValid: false, errorKey: "action_url.unsafe_url" };
  } catch {
    return { isValid: false, errorKey: "action_url.invalid_url" };
  }
}
